import * as React from 'react';
import { cn } from '@/lib/cn';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, onWheel, ...props }, ref) => {
    // A focused `type="number"` input treats the wheel as a value stepper, so
    // scrolling the page silently edits whatever figure sits under the pointer.
    // Dropping focus makes the wheel inert again and leaves the scroll itself
    // untouched. (preventDefault is not an option: React registers `wheel` as a
    // passive listener, and cancelling it would stop the page scrolling too.)
    const handleWheel = (e: React.WheelEvent<HTMLInputElement>) => {
      onWheel?.(e);
      if (type === 'number' && document.activeElement === e.currentTarget) {
        e.currentTarget.blur();
      }
    };

    return (
      <input
        type={type}
        onWheel={handleWheel}
        className={cn(
          'flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = 'Input';

export { Input };
